import { LocalStorageUtils } from '@assetmark/ui-kit/dist/utils/local-storage.utils';
import { ABOUT_YOU_KEY, GOAL_ID_KEY, GOAL_KEY, LEAD_APP_STATE, LEAD_ID_KEY, LEAD_STRATEGY_ID_KEY } from '../constants/storage.constant';
import { LeadStrategyInfoResponse } from '../lib/das-api/model/leadStrategyInfoResponse';

export const clearLocalData = () => {
    try {
        LocalStorageUtils.removeItem(LEAD_ID_KEY);
        LocalStorageUtils.removeItem(LEAD_STRATEGY_ID_KEY);
        LocalStorageUtils.removeItem(ABOUT_YOU_KEY);
        LocalStorageUtils.removeItem(LEAD_APP_STATE);
        LocalStorageUtils.removeItem(GOAL_KEY);
        LocalStorageUtils.removeItem(GOAL_ID_KEY);
    } catch {

    }
};

export const getRiskProfileId = () => {
    const leadState = LocalStorageUtils.getItem<LeadStrategyInfoResponse>(LEAD_APP_STATE);
    if(leadState.isSome()) {
        const pid = leadState.getOrElse({ riskProfileId: 0 });
        return pid.riskProfileId || 0;
    }
    return 0;
};